/**
 * Véu de pouco apurado (item 1.10, ORD-F-078/082): com `features.early_veil` e menos de 1% das seções do país apuradas,
 * as cores do mapa ficam a 45% e a legenda avisa "Ainda é cedo: as cores mudam muito no começo". O mesmo corte do
 * "Ainda é cedo" do herói (headline.ts, `sectionsFraction < 0.01`). Sem vista (antes do 1º número), sem véu: o mapa já
 * mostra "sem dados".
 */
import type { ResultsView } from '../../model/types';

/** O corte: menos de 1% das seções do país. */
export const EARLY_VEIL_FRACTION = 0.01;

export function earlyVeil(view: ResultsView | null, on: boolean): boolean {
  if (!on || !view) return false;
  const f = view.national.sectionsFraction;
  return f > 0 && f < EARLY_VEIL_FRACTION;
}
